var idioma = $('html').attr('lang');
$('.houdiniForm').each(function() {//per cada formulari
    'use strict';
        //validacio formulari
        $(this).validate({

        errorPlacement: function(error, element) {
            if (element.attr('type') === 'checkbox' || element.attr('type') === 'radio') {
                if (element.closest('div').find('input').length > 1) {
                    error.insertAfter(element.closest('div').find('p.label'));
                } else {
                    error.insertAfter(element.parent());
                }
            } else if (element.is("select")) {
                if (element.closest('div.select').length > 1) {
                    error.insertAfter(element.closest('div.select'));
                } else {
                    error.insertAfter(element.parent());
                }
            } else {
                error.insertAfter(element);
            }
        }

        /*,invalidHandler: function(form, validator) {
          var errors = validator.numberOfInvalids();
          if (errors) {
            console.log('validate');
            console.log($(this));
            if ($(this).find('.form-alert').length == 0) {
              $(this).prepend('<div class="form-alert" role="alert">S’han produït errors. Reviseu el formulari per corregir-los</div>');
            }
          }
        }*/
    });
});

//datapicker

/*$('.houdiniForm .hasDatepicker').fdatepicker({
    language: idioma,
    format: "dd/mm/yyyy",
    weekStart: 1,
    leftArrow:
    '&lt;',
    rightArrow:
    '&gt;'
});*/

//chosen
$('.houdiniForm .chzn-select').select2();

$.fn.raty.defaults.path = '/media/img';
$.fn.raty.defaults.cancel = false;

//valoracio
$('.houdiniForm .scoreField').each(function() {
    'use strict';
    var field = $(this);
    var id = '#' + field.attr('id');
    var score = $('<div></div>');
    score.raty({
        half: true,
        hints: ['', '', '', '', ''],
        score: function() {
            return field.val();
        },
        targetScore: id
    });
    field.hide();
    field.after(score);
});

//select de dnis
$('.houdiniForm .dninifnie').each(function() {
    'use strict';
    $(this).find('select').on('change', function() {
        var value = $(this).val();
        var input = $(this).closest('div.row').find('input');

        if (value === 'DNI') {
            input.rules('add', {
                dni: true,
                cifES: false,
                nieES: false
            });
        } else if (value === 'CIF') {
            input.rules('add', {
                dni: false,
                cifES: true,
                nieES: false
            });
        } else if (value === 'NIE') {
            input.rules('add', {
                dni: false,
                cifES: false,
                nieES: true
            });
        }
    });
});



function validateFiles() {

  const maxFileSizeMB = 2;
  const maxTotalSizeMB = 8;

    let totalSizeMB = 0;
    let isValid = true;
    let errorMessage = '';
    let errorMessageFile = '';


    if (($('.houdiniForm button').length > 0) && ($('#errorMessage').length === 0)) {
      $('.houdiniForm .columns:last').after('<div class="column is-12 error" id="errorMessage"></div>');
    }

    const id = $(this).attr('name');
    const file = this.files[0];

    if (file) {
        const fileSizeMB = file.size / 1024 / 1024; // Convertir el tamaño a MB
       // const errorElement = $('#fileerror' + index);
        if (fileSizeMB > maxFileSizeMB) {
            isValid = false;
            errorMessageFile = `El archivo supera los ${maxFileSizeMB} MB.`;
            $('#fileErrorSize-'+id).text(errorMessageFile);
            $(this).attr("aria-invalid", true);
            $(this).attr("required");
        } else {
           $('#fileErrorSize-'+id).text('');
           $(this).removeAttr("aria-invalid");
           $(this).removeAttr("required");


      }
    }


      $(this).each(function() {
          const file = this.files[0];

          if (file) {
              const fileSizeMB = file.size / 1024 / 1024; // Convertir el tamaño a MB
              totalSizeMB += fileSizeMB;

          }
      });


      if (totalSizeMB > maxTotalSizeMB) {
          isValid = false;
          $('#errorMessage').show();
          $('#errorMessage').text( `El tamaño total de los archivos no debe superar los ${maxTotalSizeMB} MB.`);
      } else {
        $('#errorMessage').hide();
      }

    return isValid;

}
/*
$('.houdiniForm input[type="file"]').each(function() {
  $(this).on('change', validateFiles);
});*/
